import Vue from '@/setup'

import BasketWidget from '@/modules/BasketWidget/components/BasketWidget'

import store from '@/store'

const maxAttempts = 4
reTry('basketWidget')

function reTry(widgetId, currentAttempt = 1) {
  const element = document.getElementById(widgetId)
  if (element) {
    registerWidget(element)
  } else if (currentAttempt <= maxAttempts) {
    window.setTimeout(() => reTry(widgetId, currentAttempt + 1), 2500)
  }
}

function registerWidget(element) {
  const props = element.dataset

  new BasketWidget({
    el: element,
    propsData: { ...props },
    store,
    i18n: Vue.prototype.i18n,
  })
}
